<div class="mfa-codes-modal__body">
  <c-banner
    [inline]="true"
    [style]="'success'"
    [message]="
      'REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.BANNER_MESSAGE'
        | translate
    "
    iconPositionX="top"
  ></c-banner>

  <div class="mfa-codes-modal__content">
    <div class="mfa-codes-modal__content-intro-container">
      <h3 class="mfa-codes-modal__title">
        {{
          "REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.DESCRIPTION_TITLE"
            | translate
        }}
      </h3>

      <div>
        <p class="mfa-codes-modal__description">
          {{
            "REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.DESCRIPTION_PART1"
              | translate
          }}
        </p>
        <div class="mfa-codes-modal__spacer"></div>
        <p class="mfa-codes-modal__description">
          {{
            "REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.DESCRIPTION_PART2"
              | translate
          }}
        </p>
      </div>
    </div>

    <div class="mfa-codes-modal__codes-container">
      <div class="mfa-codes-modal__codes-list">
        @for (backupcode of backupCodes.slice(0, 5); track backupcode) {
          <p>
            {{ backupcode }}
          </p>
        }
      </div>
      <div class="mfa-codes-modal__codes-list">
        @for (backupcode of backupCodes.slice(5); track backupcode) {
          <p>{{ backupcode }}</p>
        }
      </div>
    </div>

    <button
      cari-button
      class="mfa-codes-modal__action-button"
      data-shape="round"
      data-type="neutral"
      data-style="outline"
      data-size="small"
      (click)="copyToClipboard()"
    >
      <!-- icon svg -->
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_2320_1032"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_2320_1032)">
          <path
            d="M6 12.0002C5.63333 12.0002 5.31944 11.8696 5.05833 11.6085C4.79722 11.3474 4.66667 11.0335 4.66667 10.6668V2.66683C4.66667 2.30016 4.79722 1.98627 5.05833 1.72516C5.31944 1.46405 5.63333 1.3335 6 1.3335H12C12.3667 1.3335 12.6806 1.46405 12.9417 1.72516C13.2028 1.98627 13.3333 2.30016 13.3333 2.66683V10.6668C13.3333 11.0335 13.2028 11.3474 12.9417 11.6085C12.6806 11.8696 12.3667 12.0002 12 12.0002H6ZM6 10.6668H12V2.66683H6V10.6668ZM3.33333 14.6668C2.96667 14.6668 2.65278 14.5363 2.39167 14.2752C2.13056 14.0141 2 13.7002 2 13.3335V4.66683C2 4.47794 2.06389 4.31961 2.19167 4.19183C2.31944 4.06405 2.47778 4.00016 2.66667 4.00016C2.85556 4.00016 3.01389 4.06405 3.14167 4.19183C3.26944 4.31961 3.33333 4.47794 3.33333 4.66683V13.3335H10C10.1889 13.3335 10.3472 13.3974 10.475 13.5252C10.6028 13.6529 10.6667 13.8113 10.6667 14.0002C10.6667 14.1891 10.6028 14.3474 10.475 14.4752C10.3472 14.6029 10.1889 14.6668 10 14.6668H3.33333Z"
            fill="#2F3240"
          />
        </g>
      </svg>
      {{
        "REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.COPY_BUTTON"
          | translate
      }}
    </button>

    <button
      cari-button
      class="mfa-codes-modal__action-button"
      data-shape="round"
      data-type="neutral"
      data-style="outline"
      data-size="small"
      (click)="downloadCodes()"
    >
      <!-- icon svg -->
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_2320_1038"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_2320_1038)">
          <path
            d="M7.99935 10.3832C7.91046 10.3832 7.82713 10.3693 7.74935 10.3415C7.67157 10.3137 7.59935 10.2665 7.53268 10.1998L5.13268 7.79984C4.99935 7.6665 4.93546 7.51095 4.94102 7.33317C4.94657 7.15539 5.01046 6.99984 5.13268 6.8665C5.26602 6.73317 5.42435 6.66373 5.60768 6.65817C5.79102 6.65261 5.94935 6.7165 6.08268 6.84984L7.33268 8.09984V3.33317C7.33268 3.14428 7.39657 2.98595 7.52435 2.85817C7.65213 2.73039 7.81046 2.6665 7.99935 2.6665C8.18824 2.6665 8.34657 2.73039 8.47435 2.85817C8.60213 2.98595 8.66602 3.14428 8.66602 3.33317V8.09984L9.91602 6.84984C10.0493 6.7165 10.2077 6.65261 10.391 6.65817C10.5743 6.66373 10.7327 6.73317 10.866 6.8665C10.9882 6.99984 11.0521 7.15539 11.0577 7.33317C11.0632 7.51095 10.9993 7.6665 10.866 7.79984L8.46602 10.1998C8.39935 10.2665 8.32713 10.3137 8.24935 10.3415C8.17157 10.3693 8.08824 10.3832 7.99935 10.3832ZM3.99935 13.3332C3.63268 13.3332 3.31879 13.2026 3.05768 12.9415C2.79657 12.6804 2.66602 12.3665 2.66602 11.9998V10.6665C2.66602 10.4776 2.7299 10.3193 2.85768 10.1915C2.98546 10.0637 3.14379 9.99984 3.33268 9.99984C3.52157 9.99984 3.6799 10.0637 3.80768 10.1915C3.93546 10.3193 3.99935 10.4776 3.99935 10.6665V11.9998H11.9993V10.6665C11.9993 10.4776 12.0632 10.3193 12.191 10.1915C12.3188 10.0637 12.4771 9.99984 12.666 9.99984C12.8549 9.99984 13.0132 10.0637 13.141 10.1915C13.2688 10.3193 13.3327 10.4776 13.3327 10.6665V11.9998C13.3327 12.3665 13.2021 12.6804 12.941 12.9415C12.6799 13.2026 12.366 13.3332 11.9993 13.3332H3.99935Z"
            fill="#2F3240"
          />
        </g>
      </svg>
      {{
        "REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.DOWNLOAD_BUTTON"
          | translate
      }}
    </button>
  </div>

  <button
    cari-button
    class="mfa-codes-modal__finish-button"
    data-shape="round"
    data-type="neutral"
    data-style="fill"
    data-size="large"
    (click)="onClose(true)"
  >
    {{
      "REGISTER.TWO_STEP_VERIFICATION.MFA_RECOVERY_CODES_MODAL.FINISH_BUTTON"
        | translate
    }}
  </button>
</div>
